export default "__VITE_ASSET__BKEqIp90__"